import { Component } from 'react';
import { Link } from 'react-router-dom';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-white flex items-center justify-center p-6">
          <div className="text-center max-w-md">
            <div className="w-16 h-16 bg-red-50 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <span className="text-red-500 text-2xl font-bold">!</span>
            </div>
            <h1 className="text-navy-800 text-xl font-bold mb-2">Something went wrong</h1>
            <p className="text-navy-500 text-sm mb-6">We encountered an unexpected error. Please try refreshing the page.</p>
            <div className="flex items-center justify-center gap-3">
              <button
                onClick={() => { this.setState({ hasError: false }); window.location.reload(); }}
                className="bg-orange-500 hover:bg-orange-600 text-white rounded-full px-6 py-2.5 text-sm font-medium transition-colors"
              >
                Refresh Page
              </button>
              <a href="/" className="text-navy-600 hover:text-navy-800 text-sm font-medium">Go to Homepage</a>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
